(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('vvABTest', function($rootScope, vvLocalStorage, vv) {
    this.getType = function(name) {
      var ab_obj = vvLocalStorage.get('abtype') || {};
      if (ab_obj.hasOwnProperty(name))
        return ab_obj[name];

      var ls_ab_type = 'A';
      var random_number = getRandomBetween(1, 100);
      if (random_number <= 50)
        ls_ab_type = 'A';
      else
        ls_ab_type = 'B';

      ab_obj[name] = ls_ab_type;
      vvLocalStorage.set('abtype', ab_obj);

      return ls_ab_type;
    };

    this.setType = function(name, type) {
      var ab_obj = vvLocalStorage.get('abtype') || {};
      ab_obj[name] = type;

      vvLocalStorage.set('abtype', ab_obj);
    };

    var getRandomBetween = function(min, max) {
      var rand = Math.floor(Math.random() * (max - min + 1)) + min;
      return rand;
    };
  });
})(window, window.angular);
